import React, { useEffect, useState } from 'react';
import { pageTitle } from '../../helper';
import PageHeading from '../PageHeading';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import Cta from '../Cta';
import axios from 'axios';
import BASE_URL from '../../utils/api';

export default function AchievementsPage() {
  pageTitle('All Achievements');

  const [achievements, setAchievements] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchAchievements = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/achievements`);
        // Sort by year ascending (oldest to latest)
        const sorted = res.data.sort((a, b) => a.year - b.year);
        setAchievements(sorted);
      } catch (error) {
        console.error('Failed to fetch achievements:', error);
      }
    };

    fetchAchievements();
  }, []);

  return (
    <>
      {/* Page heading */}
      <PageHeading
        title="All Achievements"
        bgSrc="/images/about_hero_bg.jpeg"
        pageLinkText="Achievements"
      />
      <Spacing lg="100" md="60" />

      {/* Achievements Section */}
      <section
        className="cs-fixed_bg"
        //style={{ backgroundImage: `url(/images/resume_bg.jpeg)` }}
        data-aos="fade-up"
        data-aos-duration="4000"
      >
        <div className="cs-height_145 cs-height_lg_75" />
        <div className="container">
          <SectionHeading
            title="Awards & Achievements"
            subtitle=""
            variant="cs-style1 text-center"
            data-aos="fade-up"
            data-aos-duration="4000"
          />
          <Spacing lg="90" md="45" />
          <div className="cs-list_2_group">
            <ul className="cs-list cs-style_2 cs-mp0" data-aos="fade-up" data-aos-duration="4000">
              {achievements.slice(0, Math.ceil(achievements.length / 2)).map((item, index) => (
                <li key={index}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    className="cs-accent_color"
                    viewBox="0 0 24 24"
                  >
                    <path d="M21 3h-4V2a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v1H3a1 1 0 0 0-1 1v2a5.006 5.006 0 0 0 4 4.9V11a6.994 6.994 0 0 0 5 6.708V20H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-2v-2.292A6.994 6.994 0 0 0 18 11v-.1a5.006 5.006 0 0 0 4-4.9V4a1 1 0 0 0-1-1ZM4 6V5h3v3.874A3.005 3.005 0 0 1 4 6Zm16 0a3.005 3.005 0 0 1-3 2.874V5h3Z" />
                  </svg>
                  <h3>{item.title}</h3>
                  <p className="mb-1"><strong>{item.year}</strong></p>
                  <p className="mb-0">
                    {item.description.length > 100 ? `${item.description.slice(0, 100)}...` : item.description}
                  </p>
                </li>
              ))}
            </ul>
            <ul className="cs-list cs-style_2 cs-mp0" data-aos="fade-up" data-aos-duration="4000">
              {achievements.slice(Math.ceil(achievements.length / 2)).map((item, index) => (
                <li key={index}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    className="cs-accent_color"
                    viewBox="0 0 24 24"
                  >
                    <path d="M21 3h-4V2a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v1H3a1 1 0 0 0-1 1v2a5.006 5.006 0 0 0 4 4.9V11a6.994 6.994 0 0 0 5 6.708V20H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-2v-2.292A6.994 6.994 0 0 0 18 11v-.1a5.006 5.006 0 0 0 4-4.9V4a1 1 0 0 0-1-1ZM4 6V5h3v3.874A3.005 3.005 0 0 1 4 6Zm16 0a3.005 3.005 0 0 1-3 2.874V5h3Z" />
                  </svg>
                  <h3>{item.title}</h3>
                  <p className="mb-1"><strong>{item.year}</strong></p>
                  <p className="mb-0">
                    {item.description.length > 100 ? `${item.description.slice(0, 100)}...` : item.description}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="cs-height_150 cs-height_lg_80" />
      </section>

      {/* CTA Section */}
      <Spacing lg="100" md="70" />
      <Div className="container">
        <Cta
          title="Together, We Can Build Something <br/> <i> Great</i>?"
          btnText="Contact Our Experts "
          btnLink="/contact"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
    </>
  );
}
